import logger from '../logger';

const makeAPIRequest = async (endpoint, options) => {
  const requestOptions = options || {};
  requestOptions.headers = requestOptions.headers || {};
  requestOptions.headers['Content-Type'] = 'application/json';
  requestOptions.headers['X-Api-Key'] = process.env.API_KEY;
  requestOptions.headers['X-Api-Secret'] = process.env.API_SECRET;

  logger.info('making API request', { url: `https://${process.env.API_DOMAIN}/${endpoint}` });
  return fetch(`https://${process.env.API_DOMAIN}/${endpoint}`, requestOptions);
};

export default makeAPIRequest;
